// Feste Ereignisnamen für den GTM-dataLayer (GA4 hinter der Borlabs-
// Einwilligung). Ohne Einwilligung verarbeitet GTM die Einträge nicht weiter.
const events = {
  opened: "merkliste_geoeffnet",
  saved: "merkliste_gemerkt",
  shared: "merkliste_geteilt",
  qr: "merkliste_qr",
  imported: "merkliste_uebernommen",
  mailed: "merkliste_email",
};

/** Uses the existing dataLayer only; never sends the selection, query or fragment. */
export function trackFavoriteEvent(action, context = globalThis) {
  try {
    if (!Object.hasOwn(events, action)) return;
    const layer = context.dataLayer;
    if (!Array.isArray(layer)) return;
    layer.push({
      event: events[action],
      merkliste_seite: context.location.origin + context.location.pathname,
    });
  } catch {
    // Analytics must not interrupt saving, sharing or importing.
  }
}
